<template>
  <aha-modal
    @hide="hide()"
    :title="`Rename: ${presentation.name}`"
    action-position="justify-end"
  >
    <form @submit.prevent="handleRename()">
      <aha-input
        focus
        v-model="name"
        :maxLength="maxLength"
      />
    </form>
    <template #action>
      <aha-link @click="hide()">
        <span class="font-bold">Cancel</span>
      </aha-link>
      <aha-button
        :disabled="isLoading"
        @click="handleRename()"
        has-margin-left
      >
        <aha-spinner variant="white" v-if="isLoading" class="mr-1" />
        Save
      </aha-button>
    </template>
    <p class="pt-2 text-red-50" v-if="textError">
      {{ textError }}
    </p>
  </aha-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import PresentationApi from '@/api/presentation'

import Utils from '@/util'
import constants from '@/constant'

const { gaCategories } = constants

export default {
  props: {
    presentation: {
      type: Object,
      default: () => ({
        name: '',
      }),
    },
  },
  data() {
    return {
      name: this.presentation.name || '',
      maxLength: 100,
      isLoading: false,
      textError: '',
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
    }),
  },
  methods: {
    ...mapActions(['setErrorOnInternalServerAction']),
    async handleRename() {
      if (this.name.trim() === '') {
        this.textError = 'Please enter a name for presentation.'
        return
      }

      if (this.name === this.presentation.name) {
        this.textError = 'This is your current presentation name.'
        return
      }

      this.isLoading = true

      try {
        await PresentationApi.updatePresentationByPresentationId(
          this.presentation.id, {
            name: this.name,
          },
        )

        this.$store.state.presentations = this.$store.state.presentations.map((item) => {
          return item.id !== this.presentation.id
            ? item
            : {
              ...item,
              name: this.name,
            }
        })

        this.hide()
        Utils.showToastSuccess(`"${this.presentation.name}" renamed to "${this.name}"`)
      } catch (error) {
        this.setErrorOnInternalServerAction(`Cannot rename this presentation: ${this.presentation.name}`)
      } finally {
        Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Rename > Changed')
      }

      this.isLoading = false
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
